<template>
    <div class="banner">
        <div class="end-title" v-if="state === 'end'">
            <img src="@/assets/detail/detail-banner-title-end.png" alt="">
        </div>
        <template v-else>
            <div class="home_title_free">
                <img src="@/assets/detail/detail-banner-title.png" alt="">
            </div>
            <div class="timer">
                <bannerCountdown></bannerCountdown>
            </div>
            <div class="apply-btn"  v-if="state === 'ing'" @click="apply">
                立即申请 >
            </div>
            <div class="reserve-btn" v-else @click="reserve">
              预约提醒 >
            </div>
        </template>
        <div class="food_img" :class="{'food_img-note': stage === '第 27 期'}" :id="'detail-banner-img-' + id">
            <img :src="food_img" alt="">
        </div>
    </div>
</template>

<script>
    import bannerCountdown from "@/components/banner-countdown.vue";
    import { mapState } from 'vuex'

    export default {
        name: 'banner',
        props: ['bannerImg', 'food_img', 'state', 'id'],
        data() {
            return {
              xcxUrl: ''
            }
        },
        computed: {
            ...mapState({
                init: 'init',
                stage: 'stage'
            })
        },
        created() {

        },
        methods: {
            apply(){
                if(this.state !== 'ing'){
                    return;
                }
                this.$emit('apply')
            },

            async reserve() {
              if(this.state !== 'start'){
                return;
              }
              this.$emit('reserve')
            }
        },
        components: {
            bannerCountdown
        }
    }
</script>

<style scoped lang="scss">
    .banner {
        width: 100vw;
        height: 8.8rem;
        border-bottom: .01rem solid #ccbaa3;
        overflow: hidden;
        background: url(~@/assets/home/banner.png) center center/cover no-repeat;

        .end-title {
            width: 3.7rem;
            height: 2.07rem;
            margin: .9rem auto 0;
        }
    }

    .banner img {
        width: 100%;
    }

    .banner_logo {
        width: 28.1vw;
    }

    .home_title_free {
        width: 6.26rem;
        height: .88rem;
        margin: .68rem auto 0;


        img {
            width: 100%;
            height: 100%;
        }
    }

    .timer {
        margin-top: 10px;
    }

    .apply-btn {
        margin: .3rem auto 0;
        width: 2.2rem;
        height: .53rem;
        line-height: .53rem;
        text-align: center;
        font-size: .26rem;
        color: #fff;
        background-image: linear-gradient(-90deg, rgb(130, 11, 6) 1%, rgb(223, 28, 20) 100%);

        &:active {
            opacity: .9;
        }

        &.disabled {
            background-image: linear-gradient(-90deg, rgb(133, 133, 133) 1%, rgb(106, 106, 106) 100%);
        }
    }
    .reserve-btn {
      margin: .3rem auto 0;
      width: 2.2rem;
      height: .53rem;
      line-height: .53rem;
      text-align: center;
      font-size: .26rem;
      color: #fff;
      background: linear-gradient(0deg, #0C73D8 1%, #0C73D8);

      &:active {
        opacity: .9;
      }
    }

    .food_img {
        margin: .3rem auto 0;
        width: 4rem;
        height: 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .food_img-note{
        width: 4.3rem;
        height: 4.3rem;
        margin-top: -.05rem;
    }
</style>
